import { api } from '../api';

export const create = (values: any) => api.post('/contact/create', { ...values });
